<style scope>
</style>

<template>
  <prospect-piller/>
</template>

<script>
  import ProspectPiller from './ProspectPiller'

  export default {
    components: {ProspectPiller}
  }
</script>



// WEBPACK FOOTER //
// src/pages/cliente/Form.vue